export interface PerformSearchParams {
  searchTerms?: string;
  catalog?: string;
  pageLength?: number;
  hits?: boolean;
  start?: number;
  facets?: boolean;
  store?: string;
  fieldValueFilter?: { [key: string]: Array<string> };
  predefinedFilters?: PredefinedFilter[];
  addFacetName?: string;
  addFacetValue?: string;
  removeFacetName?: string;
  removeFacetValue?: string;
  excludeFacetName?: string;
  filter?: Filter; // For plp flow we need to pass programcode as filter
  sortBy?: string; // For plp flow sortBy option is passed for sorting the results
  clearFilter?: boolean; // if this flag is true we are clearing old filter before performing the search
  clearSort?: boolean; // if this flag is true we are clearing old sorting paramters before performing the search
  isPlpSearch?: boolean;
  isCatalogSet?: boolean;
  categoryId?: string;
  isbnList?: Array<string>;
  programIdList?: Array<string>;
  requireProgramData?: boolean;
  programId?: string;
  forceIsbnSearch?: boolean;
}

export interface PerformIsbnSearchParams {
  businessUnit: string;
  identifiers: Array<string>;
  isInternational: boolean;
}

export declare interface SearchResult {
  score: number;
  document: SearchResultDocument;
}

export declare interface BreadCrumbItem {
  label: string;
  seoLabel: string;
  value: string;
}

export declare interface SearchResultDocument {
  IS_MASTER: boolean;
  contributors: Array<string>;
  copyrightYear: number;
  currency: string;
  description: string;
  documentType: string;
  EDITION: number;
  gradeLevels: string;
  id: string;
  image: string;
  instructorOnly: boolean;
  isbn: string;
  isbn13: string;
  mhid: string;
  price: number;
  publicationDate: string;
  publicationStatus: string;
  seoTitle: string;
  optimizedUniqueTitle: string;
  title: string;
  titleType?: string | null;
  type: string;
  path: string;
  imagePath: string;
  everGreenProduct?: boolean;
  is_evergreen: any;
  businessUnit?: string;
  breadCrumbItems?: BreadCrumbItem[];
  RELATED_PRODUCTS?: string[];
}

export declare interface SearchFacetValue {
  name: string;
  label: string;
  count: number;
  children?: Array<SearchFacetValue>;
  selected: boolean;
}

export declare interface SearchFacet {
  name: string;
  label: string;
  facetValues: Array<SearchFacetValue>;
}

export declare interface SearchResults {
  hits: Array<SearchResult>;
  facets: Array<SearchFacet>;
  total: number;
}

export interface Filter {
  type: string;
  paramName: string;
  value: string;
  conditionalOperator: string;
}

export interface PredefinedFilter {
  filterName: string;
  filterValues: Array<string>;
}

export declare interface SearchRequest {
  hits?: boolean;
  searchTerms: string;
  catalog: string;
  pageLength: number;
  start: number;
  facets: boolean;
  store?: string;
  fieldValueFilter?: { [key: string]: Array<string> };
  excludeFacetName?: string;
  filter?: Filter;
  sorts?: Array<Sort>;
  sortBy?: string;
  isPlpSearch?: boolean;
  categoryId?: string;
  isbnList?: Array<string>;
  programIdList?: Array<string>;
  requireProgramData?: boolean;
  forceIsbnSearch?: boolean;
}

export declare interface Sort {
  name: string;
  direction: 'DESCENDING' | 'ASCENDING';
}

export declare interface SearchState {
  search: {
    data?: SearchResults;
    request?: SearchRequest;
    isLoading: boolean;
    isLoaded: boolean;
    isSuccess: boolean;
    isFailure: boolean;
    message: string;
    view?: ViewType;
    isCustomISBN?: boolean;
  };
  selectedCatalog?: string;
  predefinedFilters: Array<PredefinedFilter>;
  searchPageType?: string;
  currentPageIndex?: number;
  currentPageLength?: number;
  blockedCount?: number;
}

export enum ViewTypeLabel {
  LIST = "list",
  CARD = "card"
}

export type ViewType = ViewTypeLabel.LIST | ViewTypeLabel.CARD;

export interface SearchClickthroughRequest {
  searchTerms: string;
  catalog: string;
  documentId: string;
}
